import { useEffect, useRef, useState } from 'react';

/**
 * Animate a numeric value from previous to next over `durationMs` using ease-out cubic.
 * Returns the current animated value to render.
 */
export function useCountUp(target, durationMs = 600) {
  const [current, setCurrent] = useState(target);
  const fromRef = useRef(target);
  const startRef = useRef(null);
  const rafRef = useRef(null);

  useEffect(() => {
    if (current === target) return;
    fromRef.current = current;
    startRef.current = null;
    cancelAnimationFrame(rafRef.current);

    const tick = (ts) => {
      if (startRef.current == null) startRef.current = ts;
      const elapsed = ts - startRef.current;
      const t = Math.min(1, elapsed / durationMs);
      const eased = 1 - Math.pow(1 - t, 3); // ease-out cubic
      const next = fromRef.current + (target - fromRef.current) * eased;
      setCurrent(t >= 1 ? target : next);
      if (t < 1) rafRef.current = requestAnimationFrame(tick);
    };
    rafRef.current = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(rafRef.current);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [target, durationMs]);

  return current;
}

export default useCountUp;
